import {CommonMethods} from '@PosterWhiteboard/common-methods';

/**
 * Max time difference in seconds that the audio and video can be out of sync
 */
const MAXIMUM_SYNC_THRESHOLD = 0.5;

interface SyncToPageClockProps {
  getDuration(): number;
  getCurrentTime(): number;
  getPageDuration(): number;
  seek(time: number): Promise<void>;
  stopFunction(): Promise<void>;
  pauseAtEnd: boolean;
}

export class SyncToPageClock extends CommonMethods {
  private syncing = false;
  private enable = true;
  private props: SyncToPageClockProps;

  constructor(props: SyncToPageClockProps) {
    super();
    this.props = props;
  }

  public disable(): void {
    this.enable = false;
  }

  public async syncToPage(pageTime: number): Promise<void> {
    if (this.syncing || !this.enable) {
      return;
    }

    this.syncing = true;
    try {
      await this.syncItemToTime(pageTime);
    } finally {
      this.syncing = false;
    }
  }

  private async syncItemToTime(pageTime: number): Promise<void> {
    if (pageTime >= 0 && pageTime <= this.props.getPageDuration()) {
      const relativeReferenceTime = this.props.pauseAtEnd ? pageTime : pageTime % this.props.getDuration();
      const currentTime = this.props.getCurrentTime();

      if (Math.abs(relativeReferenceTime - currentTime) > MAXIMUM_SYNC_THRESHOLD) {
        await this.props.seek(relativeReferenceTime);
      }
    } else {
      await this.props.stopFunction();
    }
  }
}
